import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchProductionStageList = ({commit}) => {

    axios.get('/productionStage/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setProductionStageList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchAllProductionStageList = ({commit}) => {

    axios.get('/productionStage/allStages.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setProductionStageAllList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchAllProductionStageListWithSubProcess = ({commit}) => {

    axios.get('/productionStage/allStagesWithSubProcess.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setProductionStageAllList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


export const fetchProductionStageData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/productionStage/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setProductionStageData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetProductionStageData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitProductionStageData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/productionStage/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchProductionStageData', {id: payload.id})
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteProductionStageData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/productionStage/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchProductionStageList', {type: payload.type})
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateProductionStageSlNoData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/productionStage/updateProductionStageSlNoData.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-1'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/productionStage/actions.js